import Carrussel from './Carrussel';

export default function Component(props) {
    return <Carrussel {...props} />;
}
